export default __webpack_public_path__ + "static/media/100_15918.45878e88.jpg";